const Environment = () => {
    var isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    var isQA = Boolean(
        window.location.href.match("source-qa") ||
        window.location.href.match("qa.")
    );

    var isSource = Boolean(
        window.location.href.match("source-")
    );

    return {
        isLocalhost: isLocalhost,
        isQA: isQA,
        isTest: (isQA || isLocalhost),
        isSource: isSource
    };
}
const switchURLapi = (LocalHost, QADomain, PRODDomain) => {
    if (Environment().isLocalhost) {
        return LocalHost;
    } else {
        if (Environment().isQA) {
            return QADomain;
        } else {
            if (Environment().isQA) {
                return QADomain;
            } else {
                return PRODDomain;
            }
        }
    }
}

const apiURL = switchURLapi("https://localhost:44381/api/",
    "http://source-qa-a.ynet.co.il/mShort/generics/Leads/api/api/",
    "https://z.ynet.co.il/mShort/generics/Leads/api/api/");

export {
    Environment,
    apiURL
}


// WEBPACK FOOTER //
// ./src/Components/Services/Base.js